import { app } from '../../../../app';
import { Controller } from './application-configuration.controller';

app.component('companyManageApplicationConfiguration', {
    bindings: {
        application: '<',
        companyDomains: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./application-configuration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration.component.js